import eproViewerComponent from './eproViewer.component';

const eproViewerModule = angular.module('app.components.clinicalData.eproViewer', [])
	.component('clinicalDataEproViewer', eproViewerComponent)
	.name;

export default eproViewerModule;
